import { User } from '@types'
import { hex2HexAlpha, stringToColor } from '@utils/color'

import { UserBadgeSize } from './UserBadge.types'

import { Container, BadgeContainer, ShortUsernameLabel, UsernameLabel } from './UserBadge.styled'

import { getFirstLetter } from '@utils/string'

interface Props {
  user: User
  displayLabel?: boolean
  size?: UserBadgeSize
  color?: 'white'
  opacity?: number
  onClick?: () => void
}

export const UserBadge = (props: Props): JSX.Element => {
  const { user, displayLabel = false, size = 'medium', color, opacity = 0.3, onClick } = props

  return (
    <Container>
      <BadgeContainer
        size={size}
        style={{ background: hex2HexAlpha(stringToColor(user.email || ''), opacity) }}
        onClick={onClick}
      >
        <ShortUsernameLabel size={size} style={{ color }}>
          {getFirstLetter(user.firstName)}
          {getFirstLetter(user.lastName)}
        </ShortUsernameLabel>
      </BadgeContainer>
      {displayLabel && (
        <UsernameLabel size={size}>
          {user.firstName} {user.lastName}
        </UsernameLabel>
      )}
    </Container>
  )
}
